export const mockApiActiveHeader = "x-mock-api";
